import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";
import { toast } from "react-toastify";
import SimpleMap from "../../../../components/gmaps";
import { AutoComplete } from "antd";

const FarmerPurchaseForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const [employeelist, setEmployeelist] = useState(null);

  const [marketDetailList, setMarketDetailList] = useState(null);

  const [marketDetailId, setMarketDetailId] = useState();
  const [gradeList, setGradeList] = useState(null);
  const [purchaseGradeId, setPurchaseGradeId] = useState(null);
  const [reClassGradeId, setReClassGradeId] = useState(null);

  const [totalAmount, setTotalAmount] = useState(0);
  const [loanAmount, setLoanAmount] = useState(0);

  const [balesDetails, setBalesDetails] = useState([]);

  const [farmerName, setFarmerName] = useState("");
  const [farmerId, setFarmerId] = useState("");
  const [farmerList, setFarmerList] = useState([]);
  const [cropId,setCropId]= useState("0")

  const [totalQty, setTotalQty] = useState(0);
  const [totalQtyUnitId, setTotalQtyUnitId] = useState(0);

  const [productData, setProductData] = useState([]);
  const [productId, setProductId] = useState();

  const [varietyId, setVarietyId] = useState();

  const [varietyList, setVarietyList] = useState();

  const [warehosuelatLong, setWarehosuelatLong] = useState({
    lat: "",
    lng:"",
  });

      useEffect(() => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            //console.log(lat, long);
            setWarehosuelatLong({ lat, lng });
          },
          (error) => {
            console.error(error);
          }
        );
      }, []);

  const [latLongclose, setLatLongclose] = useState(false);

  const [warehosuedata, setWarehosuedata] = useState([]);
  const [warehouseId, setWarehouseId] = useState();
  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  
  const [farmerCropPlot, setFarmerCropPlot] = useState([]);
  const [loading, setLoading] = useState(false);

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const { sendRequest: postfarmerPurchase } = useHttp();

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("emp data.output", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getGradeForGradeRateCard } = useHttp();

  const FillGradeData = (_varietyId) => {
    getGradeForGradeRateCard(
      {
        url: `/api/fillgradeforgraderatecard/?varietyId=${_varietyId}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setGradeList(data);
      }
    );
  };

  const { sendRequest: getautoFillFarmerIdNo } = useHttp();

  const FillFarmerDetail = (_warehouseId) => {
    getautoFillFarmerIdNo(
      {
        url: `/api/autoFillFarmerIdNo/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${_warehouseId}`,
        method: "Get",
      },
      (data) => {
        console.log("setFarmerList", data);
        setFarmerList(data);
      }
    );
  };


  const { sendRequest: getFarmerCropPlotList } = useHttp();

  const fillFarmercropPlotList = (_farmerId) => {
    getFarmerCropPlotList(
      {
        url: `/api/getfarmerCropPlotDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerId=${_farmerId}`,
        method: "Get",
      },
      (data) => {
        console.log("setCropPlotList", data);
        
        setFarmerCropPlot(data.output);
      }
    );
  };

 
  const { sendRequest: getFarmerLoanDetailList } = useHttp();

  const fillFarmerLoanDetailList = (_farmerId) => {
    getFarmerLoanDetailList(
      {
        url: `/api/fillFarmerLoanDetailList/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerId=${_farmerId}`,
        method: "Get",
      },
      (data) => {
        console.log("setFarmerList", data);
        var totalBalanceAmount = 0;
        if (data && data.length > 0) {
          totalBalanceAmount = data[0].totalBalanceAmount;
        }
        setLoanAmount(totalBalanceAmount);
      }
    );
  };

  const { sendRequest: getMarketDetail } = useHttp();

  const FillgetMarketDetail = (_warehouseId) => {
    getMarketDetail(
      {
        url: `/api/fillMarketDetailList/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${_warehouseId}`,
        method: "Get",
      },
      (data) => {
        setMarketDetailList(data);
        console.log("data", data);
      }
    );
  };

  const farmerfilteredOptions =
    farmerList &&
    farmerList
      .filter((item) => item.farmerName.includes(farmerName))
      .map((item) => ({
        value: item.farmerName + "(" + item.identificationNo + ")",
      }));

  const handleSearch = (value) => {
    console.log("farmerList", farmerList);

    var farmerfletrList =
      farmerList &&
      farmerList.filter(
        (item) => item.farmerName + "(" + item.identificationNo + ")" == value
      );

    frmRef.current.fieldExecutive.value = "";
    frmRef.current.areaName.value = "";
    console.log("farmerfletrList", farmerfletrList);
    if (farmerfletrList && farmerfletrList.length > 0) {
      console.log("farmerfletrList[0].farmerId", farmerfletrList[0].farmerId);
      setFarmerId(farmerfletrList[0].farmerId);
      frmRef.current.areaName.value = farmerfletrList[0].areaName;
      fillFarmercropPlotList(farmerfletrList[0].farmerId);
      fillFarmerLoanDetailList(farmerfletrList[0].farmerId);

      console.log("employeelist", employeelist);
      var employeefletrList =
        employeelist &&
        employeelist.filter(
          (item) => item.userId == farmerfletrList[0].fieldExecutiveId
        );
      console.log("employeefletrList", employeefletrList);
      if (employeefletrList && employeefletrList.length > 0) {
        frmRef.current.fieldExecutive.value = employeefletrList[0].employeeName;
      }
    }

    setFarmerName(value);
  };

  const handleTotalBalesAmount = (value) => {
    var _price = 0;
    if (productRef.current.price.value != "") {
      _price = productRef.current.price.value;
    }

    var _balesWeight = 0;

    if (productRef.current.balesWeight.value != "") {
      _balesWeight = productRef.current.balesWeight.value;
    }

    var _totalBalesAmount = _balesWeight * _price;

    productRef.current.totalBalesAmount.value = _totalBalesAmount;
  };

  const { sendRequest: getVariety } = useHttp();

  useEffect(() => {
    getVariety(
      {
        url: "/api/varieties/",
      },
      (res) => {
        setVarietyList(res);
      }
    );
  }, [getVariety]);

  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //console.log(res);

          setWarehosuedata(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getproduct } = useHttp();

  const getProductDetail = () => {
    getproduct(
      {
        url: "/api/product/",
      },
      (res) => {
        if (res) {
          //console.log("product", res);
          setProductData(res);
        }
      }
    );
  };

  useEffect(() => {
    getProductDetail();
  }, [getproduct]);

  const loadGradePrice = (id) => {
    var gradeItem = gradeList.filter((item) => item.gradeId == id);

    if (gradeItem && gradeItem.length > 0) {
      var selectedItem = gradeItem[0];
      console.log("selectedItem", selectedItem);
      productRef.current.price.value = selectedItem.rate;
      productRef.current.unitId.value = selectedItem.unitId;
      setTotalQtyUnitId(selectedItem.unitId);
    }
  };

  const { sendRequest: getFarmerPurchaseDetail } = useHttp();
  const FillFarmerPurchaseDetail = (_farmerPurchaseId) => {
    getFarmerPurchaseDetail(
      {
        url: `/api/farmerPurchaseDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerPurchaseId=${_farmerPurchaseId}`,
        method: "Get",
      },
      (data) => {
        setBalesDetails(data.BalesDetail);
        console.log("data", data);
      }
    );
  };


  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);
    //console.log(uniqueID);
    return uniqueID.toString();
  }

  const submitHandler = (e) => {
    e.preventDefault();

    if (balesDetails.length == 0) {
      toast.success("Please enter at least one product!");
      return;
    }

    setLoading(true);

    var _farmerId = "0";
    var farmerfletrList =
      farmerList &&
      farmerList.filter(
        (item) =>
          item.farmerName + "(" + item.identificationNo + ")" == farmerName
      );
    if (farmerfletrList && farmerfletrList.length > 0) {
      _farmerId = farmerfletrList[0].farmerId;
    }

    var _loanAmountdeduct = loanAmount;

    if (totalAmount <= loanAmount) {
      _loanAmountdeduct = totalAmount;
    }

    const data = {
      
      farmerPurchaseDate: moment(frmRef.current.date.value).format(
        "DD/MM/YYYY"
      ),
      farmerId: _farmerId,
      cropId:cropId,
      timeStamp: frmRef.current.time_stamp.value,
      farmerPurchaseBalesDetails: balesDetails,
      varietyId: varietyId,
      marketDetailId: marketDetailId,
      totalQty: totalQty,
      totalQtyUnitId: totalQtyUnitId,
      totalWeightQty:totalQty,
        totalWeightQtyUnitId:totalQtyUnitId,
      warehouseId: warehouseId,
      loanAmount: _loanAmountdeduct,
      totalAmount: totalAmount,
      advanceAmount: frmRef.current.advanceAmount.value,
      balanceAmount: frmRef.current.balanceAmount.value,

      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId,
    };

    if (props.update) {
      data["farmerPurchaseId"] = props.update.farmerPurchaseId;
    }else
    {
      data["farmerPurchaseId"]=generateUniqueID()
    }
    postfarmerPurchase(
      {
        url: "/api/farmerPurchaseDetail/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Farmer purchase detail ${props.update ? "updated" : "added!"}`
        );
        setLoading(false);

        props.addForm(false);

      },(error) => {
       
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      console.log("props.update", props.update);
      frmRef.current.date.value = moment(
        props.update.farmerPurchaseDate
      ).format("YYYY-MM-DD");
      setFarmerName(
        props.update.farmerName + "(" + props.update.identificationNo + ")"
      );
      setFarmerId(props.update.farmerId);

      setWarehouseId(props.update.warehouseId);
      FillgetMarketDetail(props.update.warehouseId);
      setMarketDetailId(props.update.marketDetailId);
      setVarietyId(props.update.varietyId);
      setLoanAmount(props.update.loanAmount);
      FillGradeData(props.update.varietyId);
      setTotalQty(props.update.totalQty);
      setTotalAmount(props.update.totalAmount);
      setTotalQtyUnitId(props.update.totalQtyUnitId);
      frmRef.current.advanceAmount.value = props.update.advanceAmount;
      frmRef.current.balanceAmount.value = props.update.balanceAmount;

      frmRef.current.areaName.value = props.update.areaName;
      frmRef.current.fieldExecutive.value = props.update.fieldExecutive;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");

      FillFarmerDetail(props.update.warehouseId);
      FillFarmerPurchaseDetail(props.update.farmerPurchaseId);
      // setBalesDetails(props.update.balesDetails);
      // frmRef.current.gate_pass_id.value = props.update.gatepassId;
      // frmRef.current.vehicle_id.value = props.update.vehicleId;
      // frmRef.current.driver_name.value = props.update.driverName;
      // frmRef.current.driver_contact_number.value = props.update.driverContactNo;
      // frmRef.current.start_meter_reading.value = props.update.startMeterReading;
      // frmRef.current.end_meter_reading.value = props.update.endMeterReading;
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  const submitBales = (e) => {
    e.preventDefault();

    var _tagSerialNo = productRef.current.tagSerialNo.value;
    var _balesNumber = productRef.current.balesNumber.value;
    var _price = productRef.current.price.value;
    var _purchaseGradeId = purchaseGradeId;
    var _reClassGradeId = reClassGradeId;
    var _balesWeight = productRef.current.balesWeight.value;
    var _totalBalesAmount = productRef.current.totalBalesAmount.value;
    var _reClassGradeId = reClassGradeId;
    var unitId1 = totalQtyUnitId;
    var _inputGradeName = "";
    var gradeItem = gradeList.filter((item) => item.gradeId == purchaseGradeId);

    if (gradeItem && gradeItem.length > 0) {
      _inputGradeName = gradeItem[0].gradeName;
    }
    var gradeoutItem = gradeList.filter((item) => item.gradeId == _reClassGradeId);
    var _outGradeName = "";
    if (gradeoutItem && gradeoutItem.length > 0) {
      _outGradeName = gradeoutItem[0].gradeName;
    }

    // if (parseFloat(_balesWeight ?? 0) <= 0) {
    //   toast.success("Please enter bales weight", {
    //     position: toast.POSITION.TOP_RIGHT,
    //   });
    //   return;
    // }

    // if (parseFloat(_balesWeight ?? 0) <= 0) {
    //   toast.success("Please enter bales weight", {
    //     position: toast.POSITION.TOP_RIGHT,
    //   });
    //   return;
    // }

    setBalesDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
            farmerPurchaseBalesDetailId :generateUniqueID(),
        sellingTagSerialNo: _tagSerialNo,
        balesNo: _balesNumber,
        purchaseGradeId: _purchaseGradeId,
        inputGradeName: _inputGradeName,
        price: _price,
        baleWeight: _balesWeight,
        totalBalesAmount: _totalBalesAmount,
        reClassGradeId: _reClassGradeId,
        outGradeName: _outGradeName,
        unitId: unitId1,
        
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
      },
    ]);

    setPurchaseGradeId(0);
    setReClassGradeId(0);

    productRef.current.tagSerialNo.value = "";
    productRef.current.balesNumber.value = "";
    productRef.current.price.value = "0";

    productRef.current.balesWeight.value = "0";
    productRef.current.totalBalesAmount.value = "0";
    productRef.current.unitId.value = "0";
  };

  const handleDelete = (index, e) => {
    setBalesDetails(balesDetails.filter((v, i) => i !== index));
  };

  const handleValidateQuantityChange = (event) => {
    var validator = new RegExp("^[0-9.]*$");

    var qtyvalid = validator.test(event.target.value);
    //console.log("handleValidateQuantityChange");
    //console.log(qtyvalid);
    if (qtyvalid) {
      var quantity = parseFloat(event.target.value);

      var totalquantity = parseFloat(
        productRef.current.availableQuantity.value
      );

      if (quantity > totalquantity) {
        event.target.value = 0;
        toast.success("Please enter quanitty less than total quantity", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
      event.target.value = 0;
    }
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  return (
    <>
      <Modal isOpen={close} style={customModalStyles}>
        <div>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Bales Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"balesNumber"}> Bales Number </label>
                <input
                  type={"input"}
                  id={"balesNumber"}
                  ref={(el) => (productRef.current["balesNumber"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"productId"}> Tag Serial No </label>{" "}
                <input
                  type={"input"}
                  id={"tagSerialNo"}
                  ref={(el) => (productRef.current["tagSerialNo"] = el)}
                  className="form-control"
                />{" "}
              </div>
              <div className="col-md-3">
                <label htmlFor={"productId"}> Purchase Grade </label>{" "}
                <select
                  id="productId"
                  className="form-control"
                  ref={(el) => (frmRef.current["productId"] = el)}
                  value={productId}
                  onChange={(e) => {
                    setPurchaseGradeId(e.target.value);

                    loadGradePrice(e.target.value);
                  }}
                >
                  <option>--Select Grade Name--</option>
                  {gradeList &&
                    gradeList.map((x) => (
                      <option
                        key={x.gradeId}
                        grade-id={x.gradeId}
                        value={x.gradeId}
                      >
                        {x.gradeName}
                      </option>
                    ))}
                </select>{" "}
              </div>

              <div className="col-md-3">
                {" "}
                <label htmlFor={"BalesWeight"}> Bales Weight(kg) </label>
                <input
                  type={"number"}
                  id={"balesWeight"}
                  onChange={(e) => {
                    handleTotalBalesAmount(e.target.value);
                  }}
                  ref={(el) => (productRef.current["balesWeight"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"unit"}> Price/Kg</label>
                <input
                  type={"input"}
                  id={"price"}
                  readOnly
                  ref={(el) => (productRef.current["price"] = el)}
                  className="form-control"
                />
                <input
                  name="hiddenInput"
                  value=""
                  type="hidden"
                  ref={(el) => (productRef.current["unitId"] = el)}
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"unit"}> Total Amount</label>
                <input
                  type={"input"}
                  id={"totalBalesAmount"}
                  pattern={decimalPattern}
                  ref={(el) => (productRef.current["totalBalesAmount"] = el)}
                  className="form-control"
                />
              </div>

              <div className="col-md-3">
                {" "}
                <label htmlFor={"Available"}> Reclass Grade </label>
                <select
                  id="productId"
                  className="form-control"
                  ref={(el) => (frmRef.current["reClassGradeId"] = el)}
                  value={reClassGradeId}
                  onChange={(e) => {
                    setReClassGradeId(e.target.value);
                  }}
                >
                  <option>--Select Grade Name--</option>
                  {gradeList &&
                    gradeList.map((x) => (
                      <option
                        key={x.gradeId}
                        grade-id={x.gradeId}
                        value={x.gradeId}
                      >
                        {x.gradeName}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-3">
                <br />{" "}
                <button
                  className="btn  btn-success mx-2 my-2"
                  onClick={submitBales}
                >
                  +
                </button>{" "}
              </div>
            </div>

            <hr />

            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="tableheaderrowview">
                    <th>Sr. No</th>
                    <th>Bales Number</th>
                    <th>Tag Serial No</th>

                    <th>Purchase Grade</th>
                    <th>Bales Weight(kg)</th>
                    <th>Price/Kg</th>
                    <th>Total Amount</th>
                    <th>Reclass Grade</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {balesDetails &&
                    balesDetails.map((itm, i) => {
                      return (
                        <tr key={i.srno}>
                          <td>{i + 1}</td>
                          <td>{itm.balesNo}</td>
                          <td>{itm.sellingTagSerialNo}</td>
                          <td>{itm.inputGradeName}</td>
                          <td>{itm.baleWeight}</td>
                          <td>{itm.price}</td>
                          <td>{itm.totalBalesAmount}</td>
                          <td>{itm.outGradeName}</td>
                          <td>
                            <button
                              className="btn"
                              onClick={(e) => handleDelete(i, e)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-2"></div>

              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    balesDetails.map((x) => (x["isSave"] = true));
                    var _totalBaleAmount = 0;
                    var _totalQty = 0;
                    balesDetails.forEach((item) => {
                      _totalBaleAmount += parseFloat(
                        item.totalBalesAmount || 0
                      );
                      _totalQty += parseFloat(item.baleWeight || 0);
                    });

                    console.log("_totalQty", _totalQty);
                    setTotalQty(_totalQty);
                    setTotalAmount(_totalBaleAmount);
                    var _balanceAmount = _totalBaleAmount;
                    if (loanAmount > 0) {
                      if (loanAmount > _balanceAmount) {
                        _balanceAmount = 0;
                      } else {
                        _balanceAmount = _balanceAmount - loanAmount;
                      }
                    }

                    if (frmRef.current.advanceAmount.value != "") {
                      var _advanceAmount = parseFloat(
                        frmRef.current.advanceAmount.value
                      );

                      if (_balanceAmount >= _advanceAmount) {
                        _balanceAmount = _balanceAmount - _advanceAmount;
                      } else {
                        frmRef.current.advanceAmount.value = 0;
                      }
                    }
                    console.log("_balanceAmount", _balanceAmount);

                    frmRef.current.balanceAmount.value = _balanceAmount;

                    setClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
        </div>
      </Modal>

      {latLongclose && (
        <Modal onClose={setLatLongclose}>
          <SimpleMap
            lat={warehosuelatLong.lat}
            lng={warehosuelatLong.lng}
            set={setWarehosuelatLong}
            close={setLatLongclose}
          />
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Farmer Purchase Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-2">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"warehouseId"}>{"Warehouse"}</label>

                      <select
                        id="warehouseId"
                        className="form-control"
                        ref={(el) => (frmRef.current["warehouseId"] = el)}
                        value={warehouseId}
                        required
                        onChange={(e) => {
                          setWarehouseId(e.target.value);
                          FillgetMarketDetail(e.target.value);
                          FillFarmerDetail(e.target.value);
                        }}
                      >
                        <option selected value="0">
                          --Select Warehouse--
                        </option>
                        {warehosuedata &&
                          warehosuedata.map((x) => (
                            <option key={x.id} warehouse-id={x.id} value={x.id}>
                              {x.name} {}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Market Detail"}</label>
                      <select
                        id="emp_id"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={marketDetailId}
                        onChange={(e) => {
                          setMarketDetailId(e.target.value);
                        }}
                      >
                        <option selected value="0">
                          --Select Market--
                        </option>
                        {marketDetailList &&
                          marketDetailList.map((x) => (
                            <option
                              key={x.marketDetailId}
                              marketDetail-id={x.marketDetailId}
                              value={x.marketDetailId}
                            >
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">&nbsp;</div>
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor="identification_number">Farmer Name</label>
                      <AutoComplete
                        className="form-control"
                        style={{ height: "30px" }}
                        value={farmerName}
                        options={farmerfilteredOptions}
                        placeholder="Farmer Name"
                        onChange={handleSearch}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"fieldExecutive"}>
                        {"Field Executive"}
                      </label>
                      <input
                        type={"text"}
                        id={"fieldExecutive"}
                        readOnly
                        ref={(el) => (frmRef.current["fieldExecutive"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"fieldExecutive"}>{"Area Name"}</label>
                      <input
                        type={"text"}
                        id={"areaName"}
                        readOnly
                        ref={(el) => (frmRef.current["areaName"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                  </div>
                  <div className="row">&nbsp;</div>
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"Variety_id"}>{"Crop Variety"}</label>

                      <select
                        id="varietyId"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["vmerId"] = el)}
                        value={cropId}
                        onChange={(e) => {
                           var _varietyId =0
                           var _cropId=0
                          if (e.target.value!="")
                          {
                            var cropList=farmerCropPlot.filter(item=>item.cropId==e.target.value)

                            if (cropList&&cropList.length>0)
                            {
                              _cropId=e.target.value;
                              _varietyId=cropList[0].cropVarietyId;
                            }

                          }
                          setCropId(_cropId)
                          setVarietyId(_varietyId);
                          FillGradeData(_varietyId);
                        }}
                      >
                        <option selected value="">
                          --Select Crop Variety --
                        </option>
                        {farmerCropPlot &&
                          farmerCropPlot.map((x) => (
                            <option
                              key={x.cropId}
                              vmer-id={x.cropId}
                              value={x.cropId}
                            >
                              {x.plotName +">>"+  x.cropName +">>" +x.cropVariety}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label> {"Bales Details"}</label>
                      <br />
                      <button
                        className="btn btn-sm  btn-success mx-2 my-2"
                        formNoValidate="True"
                        onClick={(e) => {
                          e.preventDefault(false);
                          // productDetails &&
                          //   setProductDetails((items) =>
                          //     items.filter((x) => x.isSave)
                          //   );
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"TotalAmount"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"totalAmount"}
                        value={totalAmount}
                        required
                        ref={(el) => (frmRef.current["totalAmount"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"LoanAmount"}>{"Loan Amount"}</label>
                      <input
                        type={"text"}
                        id={"loanAmount"}
                        required
                        value={loanAmount}
                        readOnly
                        ref={(el) => (frmRef.current["loanAmount"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"LoanAmount"}>{"Advance Amount"}</label>
                      <input
                        id={"advanceAmount"}
                        required
                        type={"number"}
                        defaultValue="0"
                        onChange={(e) => {
                          var _balanceAmount = 0;
                          if (frmRef.current.totalAmount.value != "") {
                            _balanceAmount = parseFloat(
                              frmRef.current.totalAmount.value
                            );
                          }

                          if (loanAmount > 0) {
                            if (loanAmount > _balanceAmount) {
                              _balanceAmount = 0;
                            } else {
                              _balanceAmount = _balanceAmount - loanAmount;
                            }
                          }

                          if (frmRef.current.advanceAmount.value != "") {
                            var _advanceAmount = parseFloat(
                              frmRef.current.advanceAmount.value
                            );

                            if (_balanceAmount >= _advanceAmount) {
                              _balanceAmount = _balanceAmount - _advanceAmount;
                            } else {
                              frmRef.current.advanceAmount.value = 0;
                            }
                          }

                          frmRef.current.balanceAmount.value = _balanceAmount;
                        }}
                        ref={(el) => (frmRef.current["advanceAmount"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"LoanAmount"}>{"Balance Amount"}</label>
                      <input
                        type={"text"}
                        id={"balanceAmount"}
                        readOnly
                        required
                        ref={(el) => (frmRef.current["balanceAmount"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4"> </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default FarmerPurchaseForm;
